import React, { useRef, useState, useContext } from "react"; // Importing necessary modules from React
import { Link } from "react-router-dom"; // Importing Link component from react-router-dom for navigation
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined"; // Importing PlayCircleFilledWhiteOutlinedIcon from Material-UI icons
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd"; // Importing PlaylistAddIcon from Material-UI icons
import Tooltip from "@mui/material/Tooltip"; // Importing Tooltip component from Material-UI

import { useEffect } from "react"; // Importing useEffect hook from React

import Skeleton from "@mui/material/Skeleton"; // Importing Skeleton component from Material-UI for placeholders
import placeHolderH from "../../../assets/images/placeholder.jpg"; // Importing placeholder image

import parse from "html-react-parser"; // Importing parse function from html-react-parser library for parsing HTML strings to React elements
import Player from "../../Player"; // Importing Player component
import { DOMURL, FAVOURITE } from "../../../utility/constants"; // Importing constants
import axios from "axios"; // Importing axios for making HTTP requests
import { useHistory } from "react-router-dom"; // Importing useHistory hook for navigation
import { ModalProvider, ModalContext } from "../../modal/modalContext"; // Importing ModalProvider and ModalContext for managing modals
import { SnackbarContext } from "../../snackbar/SnackbarContext"; // Importing SnackbarContext for managing snackbar
import Button from "@mui/material/Button"; // Importing Button component from Material-UI
import VolumeMuteIcon from "@mui/icons-material/VolumeMute"; // Importing VolumeMuteIcon from Material-UI icons
import VolumeOffIcon from "@mui/icons-material/VolumeOff"; // Importing VolumeOffIcon from Material-UI icons
import CommonPlayer from "../../commonPlayer"; // Importing CommonPlayer component

const ZoomThumbnail = (props) => { // Functional component definition with props parameter
  const videoRef = useRef(null); // Creating a ref for video element
  const { showSnackbar } = useContext(SnackbarContext); // Using useContext hook to get showSnackbar function from SnackbarContext
  const { openModal, setCustomModal } = useContext(ModalContext); // Using useContext hook to get openModal and setCustomModal functions from ModalContext
  const history = useHistory(); // Getting history object from useHistory hook for navigation
  const isAuth = localStorage.getItem("isConnected") === "true"; // Checking if user is authenticated
  const [name, setname] = useState(props.title.toString()); // State variable for storing title
  const [loading, setLoading] = useState(true); // State variable for loading status
  const [preview, setPreview] = useState(false); // State variable for preview status
  const [redeMoreClick, setredeMoreClick] = useState(false); // State variable for "Read More" click status

  const windowSize = useRef([window.innerWidth, window.innerHeight]); // Creating a ref for window size
  const [windowWidth, setwindowWidth] = useState(windowSize.current[0]); // State variable for window width

  useEffect(() => { // useEffect hook for handling component lifecycle
    setTimeout(() => { // Setting a timeout to simulate loading
      setLoading(false); // Updating loading state to false after timeout
    }, 500); // Timeout duration
  }, []); // Empty dependency array means this effect runs only once after the component mounts

  const readMoreFun = () => { // Function for handling "Read More" click
    setredeMoreClick(!redeMoreClick); // Toggling the state variable for "Read More" click
  };

  const handleStart = (value) => { // Function for handling player start
    if (value === true) { // If player starts
      setPreview(value); // Set preview state to true
    } else { // If player stops
      setPreview(value); // Set preview state to false
    }
  };

  const addtoMyList = async (entryid) => { // Function for adding to My List
    if (entryid !== null && entryid !== undefined && entryid !== "") { // Checking if entryid is valid
      const payload = new FormData(); // Creating a FormData object
      payload.append("entryid", entryid); // Appending entryid to FormData

      axios // Making a POST request using axios
        .post(FAVOURITE, payload, {
          headers: {
            token: localStorage.getItem("token"), // Setting token in request headers
          },
        })
        .then(function (response) { // Handling response
          if (response.data.status === "Success") { // If request is successful
            let message = response.data.message; // Getting success message from response
            showSnackbar(message, { // Showing snackbar with success message
              severity: "success",
              anchorOrigin: { vertical: "top", horizontal: "right" },
              autoHideDuration: 5000,
            });
          }
        })
        .catch(function (error) { // Handling errors
          //  console.log(error);
        });
    } else {
      // Handle case when entryid is not valid
    }
  };

  const getLink = (props) => { // Function for handling link navigation
    history.push(`${props.link}`); // Navigating to the specified link
  };

  return (
    <> {/* Fragment shorthand */}
      {props.continueWatching !== true &&
        props.continueWatching !== "undefined" &&
        props.continueWatching !== null &&
        props.continueWatching !== "" &&
        props.trailerdata &&
        props.trailerdata !== undefined &&
        props.trailerdata !== null &&
        props.trailerdata !== "" &&
        windowWidth > 1100 &&
        props.trailerdata.length > 0 && ( // Conditional rendering based on various conditions
          <div className="zoomContainer"> {/* Container for zoomed thumbnail */}
            <Button // Button for muting/unmuting video
              className="muteBtn"
              onClick={() => props.isMuted(!props.muted)}
            >
              {props.muted === true ? <VolumeOffIcon /> : <VolumeMuteIcon />} {/* Displaying mute/unmute icon based on mute state */}
            </Button>
            <div
              onClick={() => getLink(props)}
              className={`videoContainer position-relative ${props.thumb === "v_thumb" ? "vert" : "hor"
                }`} // Container for video
            >
              {props.itemIndex === props.index &&
                loading !== true &&
                props.trailerdata &&
                props.trailerdata !== undefined &&
                props.trailerdata !== null &&
                props.trailerdata !== "" &&
                props.trailerdata.length > 0 && ( // Conditional rendering of video player
                  <CommonPlayer
                    onPlayerStart={handleStart}
                    isClass="playerContainer_Wrapper"
                    cookies={props.trailerdata[0].cookies}
                    isPlayerid={`zoomplayer_${props.index}`}
                    isrefActive={false}
                    isUrl={props.trailerdata[0].download_url}
                    isLoop={false}
                    isControls={false}
                    isPlaying={true} // Autoplay the active slide
                    isMuted={props.muted} />
                )}

              <div
                className={`${preview !== true ? "videoPlayerPreview" : ""}`}
              > {/* Placeholder for video */}
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  width={"360px"}
                  height={"163px"}
                  className="placeholder d-flex align-items-center justify-content-center"
                >
                  <img src={props.imgUrl} alt="img" />
                </Skeleton>

                <img
                  src={placeHolderH}
                  className="w-100 placeholderImg"
                  alt=""
                />
              </div>
            </div>

            <div className="info position-relative"> {/* Container for video info */}
              <div className="d-flex align-items-center my-2">
                <a
                  onClick={() => getLink(props)}
                  className="d-flex align-items-center"
                >
                  <PlayCircleFilledWhiteOutlinedIcon /> Play {/* Play button */}
                </a>
                <div className="ml-auto d-flex align-items-center icons"> {/* Container for icons */}
                  {/* Add to My List icon */}
                  {/* 
                  <Tooltip
                    title="Add to My List"
                    placement="top"
                    onClick={(e) => addtoMyList(props.item.entryid)}
                  >
                    <PlaylistAddIcon className="ml-auto cursor addtoMyList" />
                  </Tooltip>
                  */}
                  {/* Share icon */}
                  {/* 
                  <Tooltip title="Share" placement="bottom">
                    <SpeedDial
                      ariaLabel="speedDial"
                      sx={{ position: "absolute", bottom: 16, right: 16 }}
                      icon={<ShareOutlinedIcon />}
                    >
                      {actions.map((action) => (
                        <SpeedDialAction
                          key={action.name}
                          icon={action.icon}
                          tooltipTitle={action.name}
                        />
                      ))}
                    </SpeedDial>
                  </Tooltip>
                  */}
                </div>
              </div>

              <h4 className="my-2">
                <a onClick={() => getLink(props)} className="border-effect">
                  {name.toLowerCase()} {/* Displaying title */}
                </a>
              </h4>
              <div
                className={`des ${redeMoreClick === true ? "show" : "hide"}`} // Conditional rendering of description
              >
                {props.des != null && parse(props.des.substr(0, 350) + "...")} {/* Parsing and displaying description */}
              </div>

              <a className="border-effect readMore" onClick={readMoreFun}>
                {redeMoreClick === true ? ( // Conditional rendering of "Read More" text
                  <span>&#8722; </span>
                ) : (
                  <span>&#43; </span>
                )}
                Read
                {redeMoreClick === true ? " Less" : " More"}
              </a>
            </div>
          </div>
        )}
    </>
  );
};

export default ZoomThumbnail; // Exporting ZoomThumbnail component
